/**
 * @fileoverview This file is generated by the Angular template compiler.
 * Do not edit.
 * @suppress {suspiciousCode,uselessCode,missingProperties,missingOverride}
 */
 /* tslint:disable */


export const styles:any[] = ['.label-for-pair[_ngcontent-%COMP%]{\n    font-weight:300\n}\n\n.label-for-pair--large[_ngcontent-%COMP%]{\n    font-size:1.1rem\n}\n\n.input--errored[_ngcontent-%COMP%]{\n    border-color: #B13D31;\n}'];
//# sourceMappingURL=data:application/json;base64,eyJmaWxlIjoiL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2xhYmVsLWlucHV0LXBhaXIvbGFiZWwtaW5wdXQtcGFpci5jb21wb25lbnQuY3NzLnNoaW0ubmdzdHlsZS50cyIsInZlcnNpb24iOjMsInNvdXJjZVJvb3QiOiIiLCJzb3VyY2VzIjpbIm5nOi8vL3Vzci9zcmMvYXBwL3NyYy9hcHAvY29tcG9uZW50cy93aWRnZXRzL2xhYmVsLWlucHV0LXBhaXIvbGFiZWwtaW5wdXQtcGFpci5jb21wb25lbnQuY3NzIl0sInNvdXJjZXNDb250ZW50IjpbIiAiXSwibWFwcGluZ3MiOiJBQUFBOzs7Ozs7OzsifQ==



// WEBPACK FOOTER //
// ./src/$$_gendir/app/components/widgets/label-input-pair/label-input-pair.component.css.shim.ngstyle.ts